var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('maker-layout',[_c('div',[_c('users-list',{attrs:{"client":_vm.maker}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }